/** Paloma Palooza brand colors (event flyer / Tequila Ocho kit). */
export const PALOMA_BURGUNDY = "#5c1a14";
export const PALOMA_BURGUNDY_PRESSED = "#451410";
export const PALOMA_ACCENT = "#5a7d8c";
export const PALOMA_DEEP_TEAL = "#2a3d45";
export const PALOMA_CREAM = "#e2d1b5";
/** Light cream tint for highlighted list rows on light backgrounds. */
export const PALOMA_ROW_BG = "#ede4d4";

// Aliases used across map UI (legacy names)
export const PALOMA_NAVY = PALOMA_BURGUNDY;
export const PALOMA_NAVY_PRESSED = PALOMA_BURGUNDY_PRESSED;
export const PALOMA_ACCENT_BLUE = PALOMA_ACCENT;
export const PALOMA_TEXT_ON_NAVY = PALOMA_CREAM;

/** Sheet / panel title (two lines in UI). */
export const PALOMA_SHEET_TITLE_LINE1 = "Paloma Palooza Passport";
export const PALOMA_SHEET_TITLE_LINE2 = "presented by Ocho Tequila";

export const PALOMA_SHEET_DESCRIPTION =
  "Check in at at least 8 participating stops on Disgo to be entered to win an exclusive prize.";

export const PALOMA_PARTIFUL_URL = "https://partiful.com/e/xOiO33xGf2CNvTyssN5N";
export const PALOMA_PARTIFUL_LINK_LABEL = "RSVP & event details on Partiful";
